import { render, staticRenderFns } from "./data_detail.vue?vue&type=template&id=6c50802f&"
import script from "./data_detail.vue?vue&type=script&lang=js&"
export * from "./data_detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploy/cp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6c50802f')) {
      api.createRecord('6c50802f', component.options)
    } else {
      api.reload('6c50802f', component.options)
    }
    module.hot.accept("./data_detail.vue?vue&type=template&id=6c50802f&", function () {
      api.rerender('6c50802f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/packs/components/pagamento/data_detail.vue"
export default component.exports